import Slider from './Slider';
import { sliderFotos } from "../SliderData/SliderDataPreWedding";

export const SliderPreWedding = () => {
    return (<Slider list={sliderFotos}/>)
};
